/**
 * Vocabulario comun del nucleo clinico (F2.1, plan maestro §5.1 y §5.4).
 *
 * Lo comparten encuentros, observaciones, problemas, alergias y medicacion. Las
 * claves viajan en ASCII; el texto visible va en los mapas `NOMBRE_DE_*`.
 */
/**
 * Lo que se sabe de un dato clinico, como valores DISTINTOS (plan §5.1).
 *
 * Un campo vacio no es «niega»: no preguntar, no saber y que no aplique son tres
 * cosas diferentes de que la paciente lo niegue, y confundirlas convierte un
 * hueco en una ausencia de enfermedad.
 */
export const ESTADOS_DE_INFORMACION = [
    'afirmado',
    'negado',
    'desconocido',
    'no-interrogado',
    'no-aplica',
];
export const NOMBRE_DE_ESTADO_DE_INFORMACION = {
    afirmado: 'Refiere',
    negado: 'Niega',
    desconocido: 'Desconocido',
    'no-interrogado': 'No interrogado',
    'no-aplica': 'No aplica',
};
/**
 * De donde viene un dato. Toda informacion longitudinal muestra su origen y su
 * fecha (plan §5.1). `legado` marca lo que viene del modelo anterior (p. ej. el
 * texto libre de alergias de la historia) y se muestra con esa procedencia, sin
 * migrarlo como si fuera estructurado.
 */
export const ORIGENES_DE_DATO = [
    'profesional',
    'paciente',
    'dispositivo',
    'importado',
    'legado',
];
export const NOMBRE_DE_ORIGEN = {
    profesional: 'Registrado por el profesional',
    paciente: 'Referido por la paciente',
    dispositivo: 'Dispositivo',
    importado: 'Importado',
    legado: 'Registro anterior',
};
/** Lado del cuerpo, para mediciones por ojo, oido o extremidad. */
export const LATERALIDADES = ['derecha', 'izquierda', 'bilateral'];
/**
 * Fecha clinica que puede ser parcial: «2019», «2019-04» o «2019-04-17». Un
 * antecedente suele recordarse por año; forzar dia y mes inventa precision.
 */
export const PATRON_FECHA_PARCIAL = /^\d{4}(?:-(?:0[1-9]|1[0-2])(?:-(?:0[1-9]|[12]\d|3[01]))?)?$/;
//# sourceMappingURL=nucleo.js.map